
import Vue from "vue"
import sanitizeHtml from "sanitize-html"

export default Vue.extend({
  async asyncData ({ $api, params, error }) {
    const [res, err] = await $api.page.getPage(params.pathMatch)
    if (err) return error({ statusCode: err.response?.status || 404 })
    return { title: res.title || "", content: res.content || "" }
  },

  data: () => ({
    title: "",
    content: "",
  }),

  head () { return { title: this.title } },

  computed: {
    html () {
      return sanitizeHtml(this.content, {
        // eslint-disable-next-line import/no-named-as-default-member
        allowedTags: sanitizeHtml.defaults.allowedTags.concat(["style", "img"]),
        allowedAttributes: {
          // eslint-disable-next-line import/no-named-as-default-member
          ...sanitizeHtml.defaults.allowedAttributes,
          "*": ["style", "class"],
        },
        allowVulnerableTags: true,
      })
    },
  },
})
